import axios from 'axios';

const instance = axios.create({
    baseURL: 'https://testfb.iconicplatform.com/test_fb_api/1.4'
});

instance.defaults.headers.common['Authorization'] = 'Bearer 88ffae9ae7509d195187481dc03e4a314c5cc3e9';


export default instance;


// WEBPACK FOOTER //
// ./src/axios.js